"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legend = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@yanzi/react-ui");
function Legend(_a) {
    var { ticks = 3, resolution = 75, max, min, tickDecimals = 1, tickUnit = '', tickFormat, getColor } = _a, props = __rest(_a, ["ticks", "resolution", "max", "min", "tickDecimals", "tickUnit", "tickFormat", "getColor"]);
    const width = 150;
    const stepDifference = (max - min) / resolution;
    const tickDifference = (max - min) / (ticks - 1);
    return (jsx_runtime_1.jsxs(react_ui_1.Box, Object.assign({ position: "absolute", left: "1rem", bottom: "1rem", width: width, height: "2.3rem" }, props, { children: [jsx_runtime_1.jsx(react_ui_1.Box, Object.assign({ position: "absolute", height: "0.5rem", top: "1.15rem" }, { children: [...new Array(resolution)].map((_, step) => (jsx_runtime_1.jsx(LegendFragment, { background: getColor(min + stepDifference * step), fixedWidth: width / resolution }, step))) }), void 0),
            jsx_runtime_1.jsx(react_ui_1.Box, Object.assign({ position: "absolute", height: "0.5rem", top: "0.65rem" }, { children: [...new Array(resolution)].map((_, step) => (jsx_runtime_1.jsx(LegendFragment, { background: react_ui_1.mixColors('#fff', getColor(min + stepDifference * step), 0.5), fixedWidth: width / resolution }, step))) }), void 0),
            jsx_runtime_1.jsx(react_ui_1.Box, Object.assign({ position: "relative", height: "1rem", fontSize: "0.65rem" }, { children: [...new Array(ticks)].map((_, i) => (jsx_runtime_1.jsx(LegendBox, Object.assign({ display: "inline-block", position: "absolute", top: 0, height: "1rem", left: i * (width / (ticks - 1)) }, { children: tickFormat ? (tickFormat(i * tickDifference + min)) : (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [(i * tickDifference + min).toFixed(tickDecimals), tickUnit] }, void 0)) }), i))) }), void 0)] }), void 0));
}
exports.Legend = Legend;
const LegendBox = react_ui_1.styled(react_ui_1.Box) `
  white-space: nowrap;

  ::after {
    content: ' ';
    display: block;
    position: relative;
    height: 1.3rem;
    top: 0;
    left: 0;
    border-top: 1px solid #000;
    border-left: 3px solid #000;
    border-top-left-radius: 3px;
  }
`;
const LegendFragment = react_ui_1.styled('div') `
  background: ${({ background }) => background};
  display: inline-block;
  width: ${({ fixedWidth }) => fixedWidth}px;
  height: 0.5rem;
`;
exports.default = Legend;
//# sourceMappingURL=Legend.js.map